<button id="work-packages-settings-button"
        [title]="text.more_actions"
        class="button last work-packages-settings-button toolbar-icon"
        opSettingsContextMenu
        opSettingsContextMenu-query="query"
        [hideTableOptions]="hideTableOptions"
        [showCalendarSharingOption]="showCalendarSharingOption">
  <op-icon icon-classes="button--icon icon-show-more"></op-icon>
</button>
